import { render, staticRenderFns } from "./NodeParamsInfo.vue?vue&type=template&id=0c8ffe50&scoped=true&"
import script from "./NodeParamsInfo.vue?vue&type=script&lang=js&"
export * from "./NodeParamsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ffe50",
  null
  
)

export default component.exports